import { useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'

import AuthenticatedLayout from 'src/app/router/layouts/authenticated-layout'
// import { paths } from 'src/config/paths'
import PublicProfileLayout from 'src/app/router/layouts/public-profile-layout'
import { useAuthState } from 'src/shared/features/auth/api/use-auth-state'
import ConsumerAuthDialog from 'src/shared/features/auth/components/consumer/auth-dialog'
// import { useCallLead } from 'src/shared/features/consumers/api/use-call-lead'
import { useCheckForUser, useUserByUsername } from 'src/shared/features/users/api/accounts/use-user-by-username'
import { usePublicProfileStore } from 'src/shared/features/users/components/public-profile/stores/use-public-profile-store'
import { getCareerLength } from 'src/shared/features/users/components/view-profile/badges-section'
import { expertiseMap } from 'src/shared/features/users/schemas/expertise'
import type { Profession } from 'src/shared/features/users/schemas/profession'
import { professionMap } from 'src/shared/features/users/schemas/profession'
// import { useIsMobile } from 'src/shared/hooks/use-mobile'
// import { useToast } from 'src/shared/hooks/use-toast'

import AppUserProfile from './app-user-profile'
import PublicUserProfile from './public-user-profile'

const UserProfile = () => {
  const { isSignedIn } = useAuthState()
  const { username } = useParams()
  // const navigate = useNavigate()
  // const isMobile = useIsMobile()
  const [authDialogOpen, setAuthDialogOpen] = useState(false)
  const { reset } = usePublicProfileStore()
  // const { mutate: callLead } = useCallLead()
  // const { toast } = useToast()
  const { data: user } = useUserByUsername(username || '')

  useEffect(() => {
    return () => {
      reset()
    }
  }, [reset])

  useCheckForUser(username || '')

  // const handleSendMessageClick = () => {
  //   if (isConsumerSignedIn) {
  //     navigate(paths.users.message.getHref(username || ''))
  //   } else if (isMobile) {
  //     const currentPath = window.location.pathname
  //     navigate(paths.consumer.auth.signup.getHref(currentPath))
  //   } else {
  //     setAuthDialogOpen(true)
  //   }
  // }

  // const handleRequestCallClick = () => {
  //   if (isConsumerSignedIn) {
  //     if (!user?.id) {
  //       toast({
  //         title: 'User not found',
  //         description: 'Please try again later',
  //         variant: 'destructive',
  //       })
  //       return
  //     }
  //     // request call
  //     callLead(
  //       { receiverId: user?.id },
  //       {
  //         onSuccess: () => {
  //           toast({
  //             title: 'Call request sent successfully',
  //             description: `Your call request has been sent to ${user?.firstName}`,
  //           })
  //         },
  //         onError: (error) => {
  //           toast({
  //             title: 'Failed to send call request',
  //             description: 'Please try again later',
  //             variant: 'destructive',
  //           })
  //           console.error('Call request error:', error)
  //         },
  //       },
  //     )
  //   } else if (isMobile) {
  //     const currentPath = window.location.pathname
  //     navigate(paths.consumer.auth.signup.getHref(currentPath))
  //   } else {
  //     setAuthDialogOpen(true)
  //   }
  // }

  const title = useMemo(() => {
    return `${user?.firstName} ${user?.lastName} - ${professionMap[user?.profession as Profession]?.label} in ${
      user?.shortAddress
    }`
  }, [user])

  const description = useMemo(() => {
    const expertiseText = user?.expertise?.length
      ? `specializing in ${user.expertise
          .map((expertise) => expertiseMap[user?.profession]?.[expertise]?.label)
          .join(', ')}`
      : ''
    const careerText = user?.careerStartDate ? `working for over ${getCareerLength(user.careerStartDate)}` : ''

    return `${user?.firstName} ${user?.lastName} is a ${
      professionMap[user?.profession as Profession]?.label
    } ${expertiseText} ${careerText} in ${user?.shortAddress}`
      .replace(/\s+/g, ' ') // Remove extra spaces
      .trim()
  }, [user])

  return isSignedIn ? (
    <AuthenticatedLayout hideFooter>
      <AppUserProfile />
    </AuthenticatedLayout>
  ) : (
    <PublicProfileLayout profile>
      <div className="mx-auto max-w-[1400px]">
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:description" content={description} />
        <meta name="twitter:description" content={description} />
        <meta property="og:image" content={user?.profilePhoto} />
        <meta name="twitter:image" content={user?.profilePhoto} />
        {/* {!isMobile && (
          <button
            className="mt-4 flex cursor-pointer flex-row items-center gap-4 px-12 text-left"
            onClick={() => navigate(paths.marketplace.getHref())}
          >
            <BackArrow className="text-muted" size={16} />
            <p className="text-muted hover:underline">Back to search results</p>
          </button>
        )} */}
        <PublicUserProfile />
        {/* <FixedFooter mobileOnly fixedHeight={false} className="py-3">
          <div className="flex w-full flex-col gap-2">
            <div className="flex w-full flex-row gap-2">
              <Button
                size="default"
                variant="link"
                onClick={handleRequestCallClick}
                className="w-full underline"
                leftIcon={<CallNow className="text-secondary" />}
              >
                Request call now
              </Button>
              <Button size="default" onClick={handleSendMessageClick} className="w-full">
                Send Inquiry
              </Button>
            </div>
            {!isConsumerSignedIn && (
              <p className="px-2 text-center text-[9px] text-muted">
                Sign in or create an account to finish sending (takes just seconds)
              </p>
            )}
          </div>
        </FixedFooter> */}
        <ConsumerAuthDialog open={authDialogOpen} onOpenChange={setAuthDialogOpen} initialView="signup" />
      </div>
    </PublicProfileLayout>
  )
}

export default UserProfile
